import { genAttributes } from '@onward-delivery/core';

export const getEditMultiPickupRequiredFields = (order) => {
    // Middle-mile orders (Receiving, Multi-Leg) have no shipper-entered pickup leg — the
    // "pickup" is the final-mile agent's warehouse, derived from the dropoff rather than
    // typed in. Requiring pickup contact/address here would block these orders on fields
    // the user can't fill. Mirrors PickupInfoModal hiding the pickup section and core
    // validate() excluding the pickup leg when is_middle_mile is set.
    if (order?.is_middle_mile) return [];

    const {
        is_custom: pu_is_custom,
        street: pu_street,
        city: pu_city,
        state: pu_state,
        zip: pu_zip,
        lat: pu_lat,
        long: pu_long,
        location: pu_location,
        location_type: pu_location_type,
    } = genAttributes(order, true);

    return [
        'pickup_name',
        'pickup_phone',
        pu_street,
        pu_city,
        pu_state,
        ...(order[pu_is_custom] ? [pu_zip, pu_lat, pu_long] : []),
        pu_location,
        pu_location_type,
    ];
};

/**
 * `['shipper_id']` when a carrier admin's new order has no shipping partner yet, else `[]`.
 *
 * Carrier admins create orders on a shipper's behalf, so an order left on the admin's own
 * account (finalizeOrders' fallback) has no partner. Saved orders are never flagged.
 *
 * @param {{ order_id?: string, shipper_id?: string }} order
 * @param {{ isCarrierAdmin: boolean, userId: string }} user
 * @returns {string[]}
 */
export const missingShipperFields = (order, { isCarrierAdmin, userId }) =>
    isCarrierAdmin && !order?.order_id && (!order?.shipper_id || order.shipper_id === userId) ? ['shipper_id'] : [];
